import React from 'react'
import './Home.css'

import Social from './Social';
import Proj from './Proj';
import Photo from './Photo';
// import Name from './Name';

function Home() {

    return (
        <wrapper id='wrap'>
            <h1 id='title'>HELLO & WELCOME</h1>
            <div id='bbox-wrap'>
                <div id='bbox-g1'>
                    {/* <Name /> */}
                    <div className="bbox" id="name">
                        JORDAN <br /> ZABINSKI
                    </div>
                    <div id='bbox-g2'>
                        <Social />
                        <Proj />
                    </div>
                </div>
                <Photo />
            </div>
            <scrip src="https://kit.fontawesome.com/d36bbed7df.js"
                crossorigin="anonymous"> </scrip>
        </wrapper>
    );
}

export default Home;